export default "/images/fcf2167a6f7514609f9e416a77a4929a.avif";